import { render, staticRenderFns } from "./Pesquisa.vue?vue&type=template&id=185183f4&scoped=true&"
import script from "./Pesquisa.vue?vue&type=script&lang=js&"
export * from "./Pesquisa.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=185183f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185183f4",
  null
  
)

export default component.exports